import React from 'react'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import SelectField from 'material-ui/SelectField'
import DatePicker from 'material-ui/DatePicker';
// import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import { RadioButtonGroup } from 'material-ui/RadioButton'
// import MenuItem from 'material-ui/MenuItem'
import AutoComplete from 'material-ui/AutoComplete';

// get timezone offset in milliseconds for the correct datepicker
var tzoffset = (new Date()).getTimezoneOffset() * 60000;

export const renderTextField = ({input, type, value, label, meta: {touched, error}, ...custom}) => (  // Define stateless component to render input and errors
  <div>
    <TextField
      type={type}
      floatingLabelText={label}
      defaultValue={value}
      {...input}
      {...custom}
    />
    {touched && error && <span className="error">{error}</span>}
  </div>
)

export const renderCheckbox = ({ input, onCheck, className, disabled, label }) => (
  <Checkbox
    className={className}
    label={label}
    checked={input.value ? true : false}
    disabled={disabled}
    onCheck={input.onChange}/>
)

export const renderRadioGroup = ({ input, ...rest }) => (
  <RadioButtonGroup {...input} {...rest}
    valueSelected={input.value}
    onChange={(event, value) => input.onChange(value)}/>
)

export const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    children={children}
    {...custom}/>
)

export const renderDatePicker = ({ input, onChange, className, label, hintText, inputStyle, selected, defaultDate, floatingLabelText, ...custom }) => (
  <DatePicker
    className={className}
    label={label}
    floatingLabelText={floatingLabelText}
    hintText={hintText}
    inputStyle={inputStyle}
    textFieldStyle={inputStyle}
    style={inputStyle}
    defaultDate={defaultDate}
    selected={selected}
    cancelLabel='mégse'
    // onChange={(event, value) => onChange ? onChange : input.onChange(value)}/>
    // onChange={(event, value) => onChange ? onChange : input.onChange(value.getTime())}/>
    onChange={(event, value) => onChange ? onChange : input.onChange(
      ( new Date( value.getTime() - tzoffset + 3600000 ) ).toISOString().slice(0,10)
    )}/>
)

export const renderAutoComplete = ({ input, dataSourceConfig, label, hintText, onNewRequest, floatingLabelText, meta: { touched, error }, dataSource, ...custom }) => (
  <AutoComplete
    floatingLabelText={label}
    {...input}
    {...custom}
    hintText={label}
    //onNewRequest={onNewRequest}
    filter={AutoComplete.noFilter}
    dataSourceConfig={dataSourceConfig}
    dataSource={dataSource}
    fullWidth={true}
    onNewRequest={onNewRequest ? onNewRequest : (selectedItem) => {
      //const value = selectedItem.id;
      input.onChange(selectedItem.text);
    }}
  />
)


// WEBPACK FOOTER //
// ./src/components/auth/form_helpers.js